import React, { useMemo } from 'react';
import type { TCredentialingContract } from 'types/credentialing';
import type { SettingEnum } from 'types/enumerationData';
import { getStateDisplayName } from 'utils/common';
import { SvgInfoCircle } from '../SvgIcons';
import s from './s.module.less';

type Props = {
    contracts: TCredentialingContract[];
    stateList?: SettingEnum[];
};

const ExpiredBanner = ({ contracts, stateList }: Props) => {
    const text = useMemo(() => {
        if (contracts.length === 0) return '';
        if (contracts.length === 1) {
            const c = contracts[0];
            return `The signing link for your ${c.payerName} contract for ${getStateDisplayName(c.payerState, stateList)} expired after 30 days. We're requesting a new contract; you'll be able to sign again when it arrives.`;
        }
        const labels = contracts.map(
            (c) => `${c.payerName} · ${getStateDisplayName(c.payerState, stateList)}`,
        );
        return `The signing links for ${contracts.length} contracts expired after 30 days (${labels.join(', ')}). We're requesting new contracts; you'll be able to sign again when they arrive.`;
    }, [contracts, stateList]);

    if (!text) return null;

    return (
        <div className={s.infoBanner}>
            <div className={s.bannerIcon}><SvgInfoCircle color="#2563EB" /></div>
            <span className={s.bannerText}>{text}</span>
        </div>
    );
};

export default ExpiredBanner;
